<rt-assistant-list-card>
  <rt-list-row-person class="person" [data]="data()" />
  @if (data().badge; as badge) {
    @if (badge.kind === 'overdue') {
      <rt-badge class="overdue-badge" color="rejected" [text]="'-' + badge.days + 'd'" />
    }
  }
</rt-assistant-list-card>
